// extracted by mini-css-extract-plugin
export default {"extendcpnblog":"c93965d60a46f23d0312","extendsteps":"dd2dbd8f58b92326c90e"};